import React, { memo } from "react";
import './style.css'

const loaderStyle = {
  height: "100vh",
  width: "100vw",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const iconStyle = {
  fontSize: "73px",
  color: "#80b927"
}


const Loader = memo(function Loader() {
  return (
    <div style={loaderStyle}>
      <div className="" role="status">
        {/* <i class="fa-solid fa-spinner fa-spin-pulse loader-icon" style={iconStyle}></i> */}
        <img src="/favicon.png" width={50} height={50} className="loader-animation pulse" />
      </div>
    </div>
  );
});

export default Loader;
